import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";
const NonSurgicalProcedures = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Non-Surgical Procedures
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        className="my-5 text-center "
        style={{
          color: "black",
          marginBottom: "80px",
          margin: "0 50px",
        }}
      >
        <p
          style={{
            // border: "1px solid red",
            padding: "8px",
            display: "inline-block",
            fontSize: "19px",
            textAlign: "start",
          }}
        >
          Dr Ahmed offers liquid nitrogen cryotherapy for warts, skin tags, and
          precancerous skin lesions; intralesional injections for keloid scars,
          alopecia; botox injections for hyperhidrosis (excessive sweating).
        </p>
      </div>
      <div className="footer-import  footer-import-contact">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default NonSurgicalProcedures;
